import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { Search as SearchIcon } from '@finect/tabular-icons/search';
import { InputContainer, ActionBlock, IconBlock } from './partials';
import { CountChip } from './CountChip';
import { Spinner } from './../../Spinner';
var SearchInput = function SearchInput(_ref) {
  var _ref$chips = _ref.chips,
    chips = _ref$chips === void 0 ? [] : _ref$chips,
    _ref$showChips = _ref.showChips,
    showChips = _ref$showChips === void 0 ? false : _ref$showChips,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    search = _ref.search,
    onChange = _ref.onChange,
    qty = _ref.qty,
    onRestoreAction = _ref.onRestoreAction,
    withCount = _ref.withCount,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Buscar' : _ref$placeholder,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var handleSearchChange = onChange ? onChange : function () {};
  var handleFocus = function handleFocus() {};
  var handleBlur = function handleBlur() {};
  var text = chips.length && showChips ? chips[0].label : '';
  var chipText = showChips ? text : String(qty);
  return React.createElement(InputContainer, {
    isFocused: open
  }, withCount ? React.createElement(ActionBlock, null, React.createElement(CountChip, {
    onAction: onRestoreAction,
    value: chipText
  })) : null, React.createElement("input", {
    autoComplete: "off",
    autoFocus: open,
    name: "searchTerm",
    placeholder: placeholder,
    value: search,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleSearchChange
  }), React.createElement(IconBlock, {
    isOpen: open
  }, loading ? React.createElement(Spinner, {
    width: "auto",
    color: "primary"
  }) : null, React.createElement(SearchIcon, {
    size: "20px"
  })));
};
export default SearchInput;